export default __webpack_public_path__ + "static/media/memoseq.fd5acd24.png";